document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper('.swiper.swiper-topbar', {
    loop: true,
    autoplay: {
      delay: 3000,
    },
    slidesPerView: 1,
    breakpoints: {
      750: {
        slidesPerView: 3,
      },
    }
  });
});
